import React, { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import { ApexAuth } from "apex-ui-services";
import isNil from "lodash.isnil";
import { Card, Header } from "semantic-ui-react";
import { legit } from "apex-legit-service";
import { RootState } from "StoreTypes";
import { connect } from "react-redux";
import { ApexApiError } from "../../types";
import {
  ALL_REQUESTED_PERMISSIONS,
  LEGIT_SERVICE_CONFIG,
} from "../../constants";
import { SSO_ERROR_MESSAGE } from "./constants";
import styles from "./styles.module.less";
import { ApexLegacyLogin } from "./ApexLegacyLogin";
import { MessageCenter } from "../../components/MessageCenter";

export const isPrimitiveEmpty = (value: string | number | undefined | null) => {
  let empty = false;
  if (isNil(value)) {
    empty = true;
  } else if (
    (value as string).length !== undefined &&
    (value as string).trim().length === 0
  ) {
    empty = true;
  }
  return empty;
};

export interface Props {
  ssoError?: ApexApiError | null;
  ssoLoginIsLoading: boolean;
  adoptLegitSession: (
    config: Record<string, any>,
    requestedPermissions: string[]
  ) => void;
  clearSsoLogin: () => void;
  isLegacyLoginLoading: boolean;
}

export const ApexLoginComponent = ({
  ssoError,
  ssoLoginIsLoading,
  adoptLegitSession,
  clearSsoLogin,
  isLegacyLoginLoading,
}: Props) => {
  const [username, setUsername] = useState("");

  // if login isn't loading get legit session
  useEffect(() => {
    if (!ssoLoginIsLoading) {
      adoptLegitSession(LEGIT_SERVICE_CONFIG, ALL_REQUESTED_PERMISSIONS);
    }
  }, [ssoLoginIsLoading]);

  // if ssoError render the legacy ui, else render okta UI
  return (
    <>
      {ssoError && (
        <Box margin="15px -15px 15px">
          <MessageCenter
            errorMessages={[SSO_ERROR_MESSAGE]}
            onDismissErrors={clearSsoLogin}
          />
        </Box>
      )}
      <Card centered className={styles.loginContainer}>
        <Card.Content>
          <Card.Header textAlign="center">
            <Header as="h1" color="blue">
              Sign In
            </Header>
          </Card.Header>
        </Card.Content>
        <Card.Content className={styles.loginContent}>
          <div id="login">
            <ApexLegacyLogin
              defaultUsername={username}
              loggingIn={isLegacyLoginLoading}
            />
          </div>
        </Card.Content>
      </Card>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    isLegacyLoginLoading: legit.selectors.isSessionLoading(state),
    ssoLoginIsLoading: ApexAuth.loginSso.selectors.isSsoLoginLoading(state),
    ssoError: ApexAuth.loginSso.selectors.error(state),
  };
};

const mapDispatchToProps = {
  adoptLegitSession: legit.adoptExistingSession,
  ssoLogin: ApexAuth.loginSso.actions.createSsoLogin.request,
  clearSsoLogin: ApexAuth.loginSso.actions.clearSsoLogin,
};

export const ApexLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApexLoginComponent);
